import {ComponentPropsFromRoute} from "../../../routers/routers";
import React, {useEffect, useMemo, useState} from "react";
import {FilterDataController} from "../../../controllers/filtered-table/filter.data.controller";
import {useTranslation} from "react-i18next";
import {columnsFactory} from "./statements-list.columns";
import {statementsService} from "../../../services/accounting/statements.service";
import {Statement, StatementSummary} from "../../../models/accounting/statements";
import {PageLoader} from "../../core/commons/page-loader/page-loader";
import {Button, Space} from "antd";
import {filtersFactory} from "./statements-list.filters";
import FilteredTable from "../../core/commons/filtered-table/filtered.table";
import {StatementsListInfo} from "./statements-list.info";
import {filterButtonsFactory} from "./statements-list.filter-buttons";
import {Export} from "../../core/commons/export/export";

interface StatementsListProps extends ComponentPropsFromRoute {}

export const StatementsList: React.FC<StatementsListProps> = () => {

    const {t} = useTranslation("translation", {useSuspense: false});

    const [summary, setSummary] = useState<StatementSummary | null>(null);

    const dataHandler: FilterDataController<Statement> = useMemo(() => new FilterDataController(request => statementsService.getList(request)), []);

    const columns = useMemo(() => columnsFactory(t, summary?.currencyCode || ""), []);
    const filters = useMemo(() => filtersFactory(t), []);
    const filterButtons = useMemo(() => filterButtonsFactory(t), []);

    const [exportModalShown, setExportModalShown] = useState<boolean>(false);

    useEffect(() => {
        statementsService.getSummary().then(summary => setSummary(summary))
    }, []);

    if (!summary) {
        return <PageLoader />
    }

    return (
        <Space direction={"vertical"} size={[30, 30]}>
            <StatementsListInfo summary={summary} />
            <FilteredTable
                columns={columns}
                dataHandler={dataHandler}
                filterKeys={filters}
                filterButtons={filterButtons}
                buttons={[
                    <Button
                        type={"primary"}
                        onClick={() => setExportModalShown(true)}
                    >{t("EXPORT.TITLE")}</Button>
                ]}
            />
            {exportModalShown ? (
                <Export
                    title={"ACCOUNTING.STATEMENTS.TITLE"}
                    isShown={true}
                    withBasicExportFields
                    config={{
                        link: "/api/v3/accounting/statements",
                        query: dataHandler.lastRequest?.toParams()
                    }}
                    onClose={() => setExportModalShown(false)}
                />
            ) : null}
        </Space>
    )
}